export const setItemToStorage = (key, value) => {
  return new Promise((resolve, reject) => {
    OfficeRuntime.storage
      .setItem(key, value)
      .then(function (result) {
        return result;
      })
      .then(function (result) {
        resolve(result);
      })
      .catch((error) => {
        const x = error.message;
        reject(x);
      });
  });
};

export const getItemFromStorage = (key) => {
  return new Promise((resolve, reject) => {
    OfficeRuntime.storage
      .getItem(key)
      .then(function (value) {
        return value;
      })
      .then(function (result) {
        resolve(result);
      })
      .catch((error) => {
        const x = error.message;
        reject(x);
      });
  });
};

export const removeItemFromStorage = (key) => {
  return new Promise((resolve, reject) => {
    OfficeRuntime.storage
      .removeItem(key)
      .then(function (value) {
        return value;
      })
      .then(function (result) {
        resolve(result);
      })
      .catch((error) => {
        const x = error.message;
        reject(x);
      });
  });
};

export const getObjectFromWorkbookStorage = async (key) => {
  let value = [];
  await Excel.run(async (context) => {
    const settings = context.workbook.settings;
    const options = settings.getItemOrNullObject(key);
    options.load("value");
    await context.sync();
    if (options && options.value) value = JSON.parse(options.value);
  }).catch(function (error) {
    console.log("Error: " + error);
  });
  return value;
};

export const setObjectToWorkbookStorage = async (key, value) => {
  await Excel.run(async (context) => {
    const settings = context.workbook.settings;
    settings.add(key, JSON.stringify(value));
    await context.sync();
  }).catch(function (error) {
    console.log("Error: " + error);
  });
};

export const getStringFromWorkbookStorage = async (key) => {
  let value = "";
  await Excel.run(async (context) => {
    const settings = context.workbook.settings;
    const options = settings.getItemOrNullObject(key);
    options.load("value");
    await context.sync();
    value = options && options.value !== undefined ? options.value : "";
  }).catch(function (error) {
    console.log("Error: " + error);
  });
  return value;
};

export const setStringToWorkbookStorage = async (key, value) => {
  await Excel.run(async (context) => {
    const settings = context.workbook.settings;
    settings.add(key, value);
    await context.sync();
  }).catch(function (error) {
    console.log("Error: " + error);
  });
};
